import { wirelessBreadcrumbsConfig } from '../core/breadcrumbs/breadcrumbs.config';
import { RouteBreadcrumbsConfig } from '../core/breadcrumbs/breadcrumbs.model';

export const changeCallerIdBreadcrumbsConfig: RouteBreadcrumbsConfig = {
  breadcrumbsData: [
    wirelessBreadcrumbsConfig,
    {
      alt: '',
      copy: 'change-caller-id.header',
      val: null,
    },
  ],
  regexp: /^change-caller-id(.+)?/,
  useRegEx: true,
  key: 'change-caller-id',
};
